/** startControl should always be lower than endControl in order for the calculations to work properly */
export type VariableValue = {
    end: number
    start: number
    endControl: number
    startControl: number
}

export const calculateValue = (variableValue: VariableValue, control: number) => {
    
    const sizeRange = (variableValue.end - variableValue.start)
    const widthRange = (variableValue.endControl - variableValue.startControl)
    const widthRelativeToMin = (control - variableValue.startControl)
    const sizeRelativeToMin = ((widthRelativeToMin / widthRange) * sizeRange)

    return (control > variableValue.endControl) ? variableValue.end
       : (control < variableValue.startControl) ? variableValue.start
                                                : (variableValue.start + sizeRelativeToMin)
}

export const easeInOut = (t: number) => (0.5 * Math.sin((t - 0.5) * Math.PI) + 0.5)
export const easeOut = (t: number) => Math.sin((t * Math.PI) / 2)

export const typeOut = (s: string, tween: number) => {
    const numberOfCharactersToType = Math.floor(s.length * tween)
    return s.substring(0, numberOfCharactersToType)
}

export const fractionUpScreen = (screenHeightInPx: number, yInPx?: number) => {
    
    const fraction: VariableValue = {
        start: 1,
        end: 0,
        startControl: 0,
        endControl: screenHeightInPx,
    }

    return yInPx ? calculateValue(fraction, yInPx)
                 : 0
}